module.exports = __webpack_public_path__ + "img/fish_half.1004c649.svg";